module.exports = __webpack_public_path__ + "img/1f984.e055b00.svg";